import type { DriveStep } from 'driver.js';

// Shared by any tour that needs to be "page-aware without route-detection
// logic" — drops any step whose element selector isn't currently in the DOM.
// Steps with no `element` (intro/closing slides) always pass through.
export function filterExistingSteps(steps: DriveStep[]): DriveStep[] {
  return steps.filter((step) => typeof step.element !== 'string' || document.querySelector(step.element) !== null);
}
